import { Link, Location } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import QueryLoader from "components/QueryLoader";
import { addItemToRecentTags, getRecentTags, tagsQuery } from "services/tags";
import { buildExerciseTagPath, isExerciseTagActive } from "pages/Exercises/urlState";

const RECENT_TAGS_MINIMUM = 3;

type Props = {
  location: Location;
};

// Recent topics are read back from localStorage, where only these two fields are kept.
type TopicItem = {
  id: string;
  name: string;
};

export default function TopicSection(props: Props) {
  const { t } = useTranslation();
  const recentTags = getRecentTags();

  const section = (topics: TopicItem[]) => (
    <SidePanelSection
      sectionTitle={t("Common.labels.popularTopics")}
      list={topics}
      location={props.location}
      tagName={TopicListItem}
      isReducedList={true}
    />
  );

  // Enough recent topics answers the section on its own, so the popular list is
  // only worth a request when there are not.
  if (recentTags.length >= RECENT_TAGS_MINIMUM) return section(recentTags);

  return (
    <QueryLoader query={tagsQuery({ page: 1, size: 5 })}>
      {data => section(data.list)}
    </QueryLoader>
  );
}

type TopicListItemProps = {
  item: TopicItem;
  location?: Location;
};

function TopicListItem(props: TopicListItemProps) {
  const handleClick = () => {
    addItemToRecentTags(props.item);
  };

  const path = buildExerciseTagPath(props.item.id);
  const isActive =
    props.location !== undefined && isExerciseTagActive(props.location, props.item.id);
  return (
    <li className={isActive ? "active" : ""}>
      <Link onClick={handleClick} to={path}>
        {props.item.name}
      </Link>
    </li>
  );
}
